export const priceFormatter = (x: number) =>
  x === undefined ? '-' : x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
